(function(){
  'use strict';

  eclipseApp.controller('changeInternetCtrl', ['$scope', '$state', 'accountDashboardManager', 'reviewSummary', function($scope, $state, accountDashboardManager, reviewSummary){

    $scope.review = {
      tos_consent: false,
      submitted: false
    };

    $scope.acknowledge = false;

    $scope.accepted = function() {

      angular.element('.ute-input-textarea').bind('scroll', function() {

        var offset = $('.read-only').offset().top + $('.read-only').height();
        var top = $('.read-only div').offset().top  + $('.read-only div').height() - offset;

        if( top <= 100 && $scope.acknowledge == false){
          $scope.$apply(function () {
            //$scope.acknowledge = true;
          });
        }

      });

      $scope.clicked = true;

      var offset = $('.read-only').offset().top + $('.read-only').height();
      var top = $('.read-only div').offset().top  + $('.read-only div').height() - offset;

      if( top <= 100 && $scope.acknowledge == false){
        $scope.acknowledge = true;
      }
      if($scope.acknowledge == false){
        $('#tos_consent').prop('checked', false);
        $scope.review.tos_consent = false;
      }
      if($scope.review.tos_consent == true && top <= 100){
        $scope.acknowledge = true;
      }



    };


    // $scope.confirmed = function() {
    //   return accountDashboardManager.confirmChangeInternetPackage();
    // };

    if (reviewSummary) {
      $scope.review.tier = reviewSummary.packageAdded;
      $scope.reviewData = $scope.review = reviewSummary;
    } else {
      $state.go('myAccount.internet');
    }


    // console.log('@changeInternetCtrl: ', accountDashboardManager.currentInternetPackage(), accountDashboardManager.newInternetPackage());


    // if($scope.confirmed() || !accountDashboardManager.currentInternetPackage || !accountDashboardManager.newInternetPackage) {
    //   $state.go('home');
    //   return;
    // }

    // NOTE: moved logic to service
    // accountDashboardManager.reviewChangeInternetPackage().then(function(resp){
    //   if(resp && resp.data && resp.data.reviewChangeInternetPkg) {
    //     angular.extend(accountDashboardManager.checkoutSession.review, {data: resp.data.reviewChangeInternetPkg});
    //     accountDashboardManager.setSession('checkoutSession', accountDashboardManager.checkoutSession);
    //     console.log('#___ ', resp);

    //     // $scope.review.tier = resp.data.reviewChangeInternetPkg.packageAdded;
    //     // TODO
    //     // fix scoping of data that caters to both buy-flow and change-internet-pckg
    //     $scope.reviewData = $scope.review = resp.data.reviewChangeInternetPkg;
    //   }
    //   else {
    //     $state.go('home');
    //   }
    // }, function(error){
    //   if (error && error.data)
    //     console.log('accountDashboardManager.reviewChangeInternetPackage()', error.data);
    //   $state.go('myAccount.internet');
    // });

    $scope.editCheckout = function(){
      $state.go('internet');
    };

    $scope.submitReview = function(){
      if($scope.review.tos_consent) {

        accountDashboardManager.submitOrder()
          .then(function(resp){
            console.log('@changeInternetCtrl:submitReview():submitOrder() (resp) ', resp);

            angular.extend(accountDashboardManager.checkoutSession.confirmation, {data: resp});
            accountDashboardManager.setSession('checkoutSession', accountDashboardManager.checkoutSession);

            accountDashboardManager.completeStep('review');
          }, function(errResp){
          _satellite.setVar("error"," FHSI|submitOrder");
           _satellite.track("bfa-fhsi-error");
            console.log('@changeInternetCtrl:submitReview:submitOrder:PROMISE:REJECTED ', errResp);
          });

        focusOnTop();
      }
      else {
        $scope.review.submitted = true;
      }
    };

    function focusOnTop (){
      window.scrollTo(0,0);
    }
  }]);
})();
